import { defineComponent, h, normalizeStyle } from 'vue'
import { aliases as mdiAliases } from 'vuetify/iconsets/mdi'
import LUCIDE_NODES from '@/icons/lucide-nodes'
import { UI_ICONS } from '@/icons/ui-icons'
import { MDI_TO_ICON, ALIAS_OVERRIDES } from '@/icons/icon-map'

const warned = new Set()
// Písmo MDI sa už nenačítava (ušetrí ~750 kB CSS a písma). Nenamapovaná ikona sa nakreslí ako otáznik v krúžku.
const FALLBACK = LUCIDE_NODES['circle-question-mark']

/** Uzly ikony podľa názvu: `mdi-*` cez mapovanie, prípadne priamo názov Lucide alebo vlastnej `ui-*` ikony. */
export function resolveIconNodes(name) {
  if (typeof name !== 'string') return null
  const key = MDI_TO_ICON[name] || name
  return UI_ICONS[key] || LUCIDE_NODES[key] || null
}

/**
 * Hrúbka čiary podľa veľkosti: pri bežných 16–24 px 1,75 (ako SF Symbols „regular“),
 * veľké ikony prázdnych stavov tenšie, aby nepôsobili ťažkopádne.
 */
function strokeWidthFor(style) {
  const normalized = normalizeStyle(style)
  const size = parseFloat(normalized && typeof normalized === 'object' ? normalized.fontSize : '')
  if (size >= 40) return 1.25
  if (size >= 28) return 1.5
  return 1.75
}

const AppIcon = defineComponent({
  name: 'AppIcon',
  props: {
    icon: { type: [String, Array, Object, Function], default: undefined },
    tag: { type: String, required: true },
  },
  setup(props, { attrs }) {
    return () => {
      let nodes = resolveIconNodes(props.icon)
      if (!nodes) {
        if (!props.icon) return h(props.tag)
        if (process.env.NODE_ENV !== 'production' && !warned.has(props.icon)) {
          warned.add(props.icon)
          console.warn(`[ikony] "${props.icon}" nemá ikonu Lucide — doplň ju do src/icons/icon-map.js`)
        }
        nodes = FALLBACK
      }
      return h(props.tag, { class: 'app-icon' }, [
        h(
          'svg',
          {
            class: 'app-icon__svg',
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': strokeWidthFor(attrs.style),
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            'aria-hidden': 'true',
            focusable: 'false',
          },
          nodes.map(([tag, nodeAttrs]) => h(tag, nodeAttrs))
        ),
      ])
    }
  },
})

/** Sada ikon appky pre Vuetify: názvy `mdi-*` kreslí ako obrysové ikony Lucide. */
export const appIconSet = { component: AppIcon }

export const appIconAliases = { ...mdiAliases, ...ALIAS_OVERRIDES }
